/**
 * @fileoverview Pure derivations over Original Ceramic glaze-color records.
 * @module glazeRecords
 */

/** Glazes that are never offered as paint colors in Custom Mosaics. */
export const HIDDEN_GLAZES = new Set(['Mackerel Gloss', 'Golden Hour Gloss']);

/**
 * @param {string} name - Glaze name
 * @returns {boolean} Whether the glaze may be offered as a paint color
 */
export function isOfferedGlaze(name) {
    return !HIDDEN_GLAZES.has(name);
}

/**
 * Derives a name→hex palette map from a records array.
 *
 * Only records with a name and a well-formed 6-digit hex make it into the
 * palette — this is the gate that decides whether a color is visible at all.
 *
 * @param {Array<Object>} records - Normalized glaze color records
 * @returns {Object<string, string>} Map of color names to hex codes
 */
export function derivePaletteFromRecords(records) {
    const map = {};
    for (const r of records || []) {
        if (r?.name && /^#[0-9a-fA-F]{6}$/i.test(r.hex)) {
            map[r.name] = r.hex;
        }
    }
    return map;
}
